// @flow

import type { HandicapOptionsType } from "@tvg/types/Race";

type GTMSelectionType = {
  label: string,
  action: string
};

type GTMTagType = {
  tag: HandicapOptionsType | number
};

export const createGTMTag = (
  handicapView: HandicapOptionsType = "basic",
  isGreyhound: boolean = false,
  runnerNumber?: number
): GTMTagType => {
  if (runnerNumber) {
    return { tag: runnerNumber };
  }

  return {
    tag:
      isGreyhound && handicapView !== "basic" && handicapView !== "advanced"
        ? "advanced"
        : handicapView
  };
};

export const createGTMLabel = (
  add: boolean,
  fromIcon: boolean
): GTMSelectionType => {
  if (add) {
    return {
      label: `Single Runner - ${fromIcon ? "Plus" : "Selection"}`,
      action: "Add To Betslip"
    };
  }
  return {
    label: "Selection",
    action: "Remove Selection From Betslip"
  };
};
